import * as React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { PaymentRecordDetail, PaymentsState } from './Types';
import { REQUESTED } from './Constants';

type Props = {
  readonly modalOpen: boolean
  readonly toggleExtraCollectionChargeModalOpen: () => void
  readonly togglePaymentDetailsModalOpen: () => void
  readonly requestCollection: (paymentHistoryId: number) => Promise<Response>
  readonly paymentRecordDetail: PaymentRecordDetail
  readonly paymentsState: PaymentsState
};

type States = {
  readonly loading: boolean
};

class ExtraCollectionChargeModalComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      this.props !== nextProps &&
      nextProps.paymentsState.paymentRecordDetails.filter((prd: PaymentRecordDetail) =>
        prd.memberName === this.props.paymentRecordDetail.memberName &&
        prd.memberId === this.props.paymentRecordDetail.memberId &&
        prd.amount === this.props.paymentRecordDetail.amount &&
        prd.chargeDate === this.props.paymentRecordDetail.chargeDate 
      )[0].collectionStatus === REQUESTED
    ) {
      this.setState(
        {loading: false},
        () => {
          this.props.toggleExtraCollectionChargeModalOpen();
          this.props.togglePaymentDetailsModalOpen();
        }
      );
    }
  }

  componentWillUnmount() {
    this.setState({loading: false});
  }

  render() {
    return (
      <Dialog
        title="Payment Collection Extra Charge Warning"
        actions={[
          this.renderCloseButton(),
          this.renderAcceptButton()
        ]}
        modal={true}
        open={this.props.modalOpen}
      >
        There will be extra charge for collecting failed payment. Do you accept?
      </Dialog>
    );
  }

  private renderCloseButton = (): JSX.Element => {
    return(
      <FlatButton
        label="Close"
        primary={true}
        onClick={this.props.toggleExtraCollectionChargeModalOpen}
        disabled={this.state.loading}
      />
    );
  }

  private renderAcceptButton = (): JSX.Element => {
    if (this.state.loading) {
      return(
        <RefreshIndicator
          size={40}
          left={0}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative'
          }}
        />
      );
    } else {
      return(
        <FlatButton label="Accept" primary={true} onClick={this.sendRequestAndClose}/>
      );
    }
  }

  private sendRequestAndClose = (): void => {
    this.setState(
      {loading: true},
      () => this.props.requestCollection(this.props.paymentRecordDetail.paymentHistoryId)
      .then()
    );
  }
}

export default ExtraCollectionChargeModalComponent;



// WEBPACK FOOTER //
// ./src/payments/ExtraCollectionChargeModalComponent.tsx